'use client';

import {useTranslations} from 'next-intl';
import {FC, useState} from 'react';
import {toast} from 'react-toastify';
import {Button, Input} from '../../../../components/commons';
import {validateEmail} from '../../../../lib/utils';
import logger from '../../../../logger';
import {Link} from '../../../../navigation';
import {ServiceFactory, ServiceTypes} from '../../../../services';

interface IProps {}

interface IState {
  email: string;
  errorMessage: string;
  isLoading: boolean;
  requestSent: boolean;
}

const userService = ServiceFactory.getServiceInstance(
  ServiceTypes.USER_SERVICE,
);

const ForgotPasswordForm: FC<IProps> = (props) => {
  const t = useTranslations('common');
  const [state, setState] = useState<IState>({
    email: '',
    errorMessage: '',
    isLoading: false,
    requestSent: false,
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      setState({...state, isLoading: true, errorMessage: ''});
      if (!validateEmail(state.email)) {
        setState({
          ...state,
          errorMessage: t('ForgotPasswordForm.insert-valid-email'),
        });
        return;
      }
      const response = await userService.forgotPassword(state.email);

      if (response.success) {
        toast.success(t('ForgotPasswordForm.mail-sent'));
        setState({...state, requestSent: true});
      } else {
        setState({
          ...state,
          errorMessage: t('ForgotPasswordForm.request-error'),
        });
      }
    } catch (err) {
      logger.error(err);
    } finally {
      setState({...state, isLoading: false});
    }
  };

  const onChange = (event) => {
    setState({...state, email: event.target.value, errorMessage: ''});
  };

  return (
    <form className="py-2" onSubmit={handleSubmit}>
      <div className="form-group">
        <Input
          label={t('ForgotPasswordForm.label.email')}
          value={state.email}
          onChange={onChange}
          name="email"
          disabled={state.isLoading || state.requestSent}
        />
        {state.errorMessage && (
          <p className="text-danger">{state.errorMessage}</p>
        )}
      </div>
      <div className="mb-3">
        <em>{t('ForgotPasswordForm.description')}</em>
      </div>
      <div style={{textAlign: 'end'}}>
        {state.requestSent && (
          <Link href={'/auth/signin'} replace={true}>
            {t('ForgotPasswordForm.back-to-login')}
          </Link>
        )}
        <Button
          className="ml-3 mr-0"
          label={t('ForgotPasswordForm.send')}
          isSpinning={state.isLoading}
          type="submit"
          disabled={state.email === '' || state.requestSent}
          onClick={() => {}}
          style={{}}
        />
      </div>
    </form>
  );
};

export default ForgotPasswordForm;
